import React, { useContext, useEffect, useRef, useState } from 'react'


import styled from 'styled-components'
// import { Text } from 'rebass'
import { init, dispose } from 'klinecharts'
import { useTranslation } from 'react-i18next'

// import { ReactComponent as Candle } from '../../assets/images/kline_candle.svg'
// import { ReactComponent as Line } from '../../assets/images/kline_area.svg'
import { ReactComponent as Twitter } from '../../assets/images/twitter.svg'
import { ReactComponent as Block } from '../../assets/images/blockscan.svg'
import { ReactComponent as Website } from '../../assets/images/website.svg'
import store from '../../utils/store'
import Column from '../../components/Column'
import { RowBetween } from '../../components/Row'
import { ButtonPrimary } from '../../components/Button'
import { RouteComponentProps } from 'react-router-dom'
import { DEFAULT_EXPLORE_URL } from '../../constants/explore'
import { desensitizeNumber, desensitizeString, formatChg, formatTime, getColor, getSizeUnit, getTokenLogoURL, loadDefaultImage, transformData } from '../../utils/exploreUtil'
import { ThemeContext } from 'styled-components'
// import { MouseoverTooltip } from '../../components/Tooltip'
// import { RowBetween } from '../../components/Row'
import Logo from '../../assets/images/goswap_logo.png'
import LogoDark from '../../assets/images/goswap_logo_dark.png'
import { useDarkModeManager } from '../../state/user/hooks'

const TwitterIcon = styled(Twitter)`
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-right:4px;
  > * {
    stroke: ${({ theme }) => theme.text1};
    fill: ${({ theme }) => theme.text1};
  }
`
const BlockIcon = styled(Block)`
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-right:4px;
  > * {
    stroke: ${({ theme }) => theme.text1};
    fill: ${({ theme }) => theme.text1};
  }
`

const WebsiteIcon = styled(Website)`
  width: 20px;
  height: 20px;
  margin-right:4px;
  cursor: pointer;
  > * {
    stroke: ${({ theme }) => theme.text1};
    fill: ${({ theme }) => theme.text1};
  }
`



// const CandleIcon = styled(Candle)`
//   width:26px;
//   height: 26px;
//   cursor: pointer;
//   @media only screen and (min-width: 960px) {
//     width: 32px;
//     height: 32px;
//   }  
//   > * {
//     stroke: ${({ theme }) => theme.text1};
//     fill: ${({ theme }) => theme.text1};
//   }
// `
// const LineIcon = styled(Line)`
//   width: 18px;
//   height: 18px;
//   cursor: pointer;
//     > * {
//     stroke: ${({ theme }) => theme.text1};
//     fill: ${({ theme }) => theme.text1};
//   }
//   @media only screen and (min-width: 960px) {
//     width: 20px;
//     height: 20px;
//   }  
// `



const ExploreDetailWrapper = styled.div`
  width:100%;
  padding:0px 12px;
  display:flex;
  flex-direction:column;
  @media only screen and (min-width: 960px) {
     width:80%;
  }
//   padding:0px 60px 0px 80px;
`

const RowView = styled.div`
  width:100%;
  display:flex;
  flex-direction:column;
  padding:10px 0px;
  @media only screen and (min-width: 960px) {
     flex-direction:row;
  }
`

const InfoText = styled.span`
  display:inline-block;
  color:${({ theme }) => theme.text1};
  margin-right:10px;
  font-size:14px;
  line-height:21px;
  letter-spacing:0px;
  text-align:left;
  white-space:wrap;
//   max-height:300px
`

const Row = styled.div<{ style?: any }>`
  display: flex;
  padding: 0px 0px;
  height:40px;
  /* border-radius:20px;
  border: 1px solid ${({ theme }) => theme.bg3}; */
  flex-direction: row;
//   justify-content: space-between;
  align-items: center;
  font-size:14px;
  @media only screen and (min-width: 960px) {
    font-size:18px;
  }
`
const ActiveView = styled.div<{ active?: boolean; hideOnMobile?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 0px;
  font-weight:500;
  margin-right: 18px;
  font-size:12px;
  border-bottom: 2px solid ${({ theme, active }) => (active ? '#014FFF' : 'transparent')};
  cursor:pointer;
  :hover {
    color: ${({ theme }) => theme.text2};
  }
  @media only screen and (min-width: 960px) {
     font-size:14px;

  }
   ${({ hideOnMobile }) =>
    hideOnMobile &&
    `
    @media only screen and (max-width: 959px) {
      display: none;
    }
  `}
   
`
const Icon = styled.img<{ size: number }>`
  width:${({ size }) => size}px;
  height:${({ size }) => size}px;
  margin-right: 4px;
  border-radius: ${({ size }) => size / 2}px;
`;

const TitleList = styled.div`
  display:flex;
  flex-direction:row;
  align-items:center;
  padding:10px 0px;
`

const Title = styled.span<{ active: boolean, hideOnPc?: boolean }>`
  display: flex;
  align-items: center;
  pointer-events: auto;
  justify-self: flex-start;
  margin:0px 12px 0px 0px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  color: ${({ theme, active }) => active ? theme.text1 : theme.text2};
  border-bottom: 3px solid ${({ theme, active }) => (active ? '#014FFF' : 'transparent')};
  :hover {
    color: ${({ theme }) => theme.text1};
  }
  @media only screen and (min-width: 960px) {
    display:${({ hideOnPc }) => hideOnPc ? 'none' : 'flex'};
    font-size: 1.25rem;
  }  
`
const TableView = styled.div`
  
  width:100%;
  /* border:1px solid;
  border-color:${({ theme }) => theme.bg3}; */
  /* border-radius:20px; */
  overflow:hidden;
  white-space: nowrap;
  overflow-x: auto;
`
const Table = styled.table`
  font-size: 0.75rem;
`
const Tr = styled.tr`
  height: 30px;
`
const Td = styled.td`
  
`
const Th = styled.th`
  
`


const TableHeader = styled.div`
  display:flex;
  flex-direction:row;
  align-items:center;
  /* padding:10px 20px;
  background-color:${({ theme }) => theme.bg3}; */
  /* @media only screen and (max-width: 960px) {
    flex-shrink: 0;
    width: fit-content; 
  } */
`
const TableText = styled.div<{ hideOnMobile?: boolean; flexBasis?: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.text1};
  font-weight: 500;
  min-width: ${({ flexBasis }) => (flexBasis ? '40px' : '100px')}; /* Adjust min-width for mobile */
  flex: ${({ flexBasis }) => flexBasis || 1}; /* Use flexBasis for more control */

  /* Hide on mobile if specified, but ensure it doesn't break layout if not hidden */
  ${({ hideOnMobile }) =>
    hideOnMobile &&
    `
    @media only screen and (max-width: 959px) {
      display: none;
    }
  `}

  @media only screen and (min-width: 960px) {
    display: flex;
    font-size: 15px;
    min-width: 180px; /* Restore larger min-width for desktop */
  }
`;

const LiquidityView = styled.div`
  display:flex;
  flex-direction: row;
  height: 45px;
  border-radius:5px;
  background-color:#FFFFFF1A;
  padding: 0px 18px;
  align-items: center;
  justify-content: space-between;
 
  
`

const ListItem = styled.div`
  display:flex;
  flex-direction:row;
  align-items:center;
  padding:10px 0px;
  /* :hover {
  
    background-color:${({ theme }) => theme.bg3};
    cursor: pointer;    
  } */
  /* @media only screen and (max-width: 960px) {
    flex-shrink: 0;
    width: fit-content; 
  } */
`
const KLineView = styled.div`
  display:flex;
  flex-direction: column;
  width:100%;
  @media only screen and (min-width: 960px) {
    width:60%;
  }
`
const InfoBody = styled.div<{ hide?: boolean }>`
  display:${({ hide }) => hide ? 'none' : 'flex'};
  flex-direction: column; 
  width: 100%;
  font-weight: 500; 
  font-size: 24px; 
  margin-top: 20px;
//   margin-left: '5%';
  @media only screen and (min-width: 960px) {
    display:${({ hide }) => hide ? 'flex' : 'none'};
    width:40%;
    margin-left: 5%;
    margin-top: 0px;
  }
`
const HideView = styled.div<{ hide?: boolean }>`
  display:${({ hide }) => hide ? 'none' : 'flex'};
  flex-direction: column; 
  width: 100%;
  @media only screen and (min-width: 960px) {
    display:${({ hide }) => hide ? 'flex' : 'none'};
  }
`

const HeaderView = styled.div`
  display:flex;
//   flex-direction:column;
//   justify-content:space-between;
//   @media only screen and (min-width: 960px) {
    flex-direction:row; 
    align-items:center;
    justify-content:space-between;
//   }
`

const ChartView = styled.div`
    width:100%;
    height:300px;
    display: flex;
    justify-content: center;
    align-items: center;
  @media only screen and (min-width: 960px) {
    height:400px;
  }
`
const CoinName = styled.div`
   display: flex;
   flex:1;
//    flex-direction: row;
   justify-content: space-between;

//    @media only screen and (min-width: 960px) {
    flex-direction: column;
//   }
 
`

const RowBetweenView = styled(Row)`
  justify-content: space-between;
  border-radius:0px;
  border:none;
  font-size:12px;
  font-weight:500;
  @media only screen and (min-width: 960px) {
    justify-content: space-between;
    font-size:14px;
  }
`
const TextView = styled.div<{ fontWeight?: number }>`
  font-size:12px;
  display: flex;
  font-weight: ${({ fontWeight }) => fontWeight || 400};
  flex-direction: column;
  @media only screen and (min-width: 960px) {
    flex-direction: row;
    font-size:14px;
    align-items: center;
  }
`

const TradeButton = styled(ButtonPrimary)`
//   width: calc(100% - 24px);
//   position: absolute;
 /* display: none; */
  min-width:80px;
  width: fit-content;
  padding:0px 18px;
  height: 45px;
  border-radius:5px;
  background-color: '#014FFF';
  min-width: 120px;
//   width: calc(100% - 24px);
//   position: absolute;
  font-size:14px;
//   bottom: 20px;
  border-radius:5px;
  @media only screen and (min-width: 960px) {
    height: 45px;
    /* width:32%; */
    font-size:16px;
  }
`



export default function ExploreDetail({ match, history }: RouteComponentProps) {
  const { t } = useTranslation()

  const chart = useRef<any>()
  const [klineType] = useState('candle')
  const [timeType, setTimeType] = useState('15m')
  const [tabIndex, setTabIndex] = useState(0)
  const [info, setInfo] = useState<any>({})

  const theme = useContext(ThemeContext)
  //元数据
  // const [metaData, setMetaData] = useState<any>({})


  //交易历史
  const [tradeHistory, setTradeHistory] = useState<Array<any>>([])
  //流动性记录
  const [liquidityHistory, setLiquidityHistory] = useState<Array<any>>([])

  const klineData = useRef<Array<any>>([])

  const [isDark] = useDarkModeManager()


  useEffect(() => {
    initCharts()

    getPairDetail()
    getKlineData()
    getTradeHistory()
    getLiquidityHistory()
    getMetaData()
    return () => {
      dispose('chart')
    }
  }, [])

  useEffect(() => {
    getKlineData()
  }, [timeType])

  //获取交易对详情
  const getPairDetail = () => {
    let params = (match.params || {}) as any
    let chain_id = params.chain_id;
    let pair_address = params.address;
    let url = `${DEFAULT_EXPLORE_URL}/api/pairs/${chain_id}/${pair_address}`
    fetch(url, { method: 'GET' })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setInfo(data.data)

        }
      })
  }

  //获取k线数据
  const getKlineData = () => {
    let params = (match.params || {}) as any
    let chain_id = params.chain_id;
    let pair_address = params.address;
    let url = `${DEFAULT_EXPLORE_URL}/api/pairs/${chain_id}/${pair_address}/kline?interval=${timeType}&limit=100`
    fetch(url, { method: 'GET' })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          //
          klineData.current = data.data.data.reverse()
          chart.current.applyNewData(klineData.current)
        }
      })
  }

  //获取元数据
  const getMetaData = () => {
    let params = (match.params || {}) as any
    let chain_id = params.chain_id;
    let pair_address = params.address;
    let url = `${DEFAULT_EXPLORE_URL}/api/metadata/tokens/${chain_id}/${pair_address}`
    fetch(url, { method: 'GET' })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          // setInfo(data.data)
          // setMetaData(data.data)
        }
      })
  }


  //获取交易历史
  const getTradeHistory = () => {
    let params = (match.params || {}) as any
    let chain_id = params.chain_id;
    let pair_address = params.address;
    let url = `${DEFAULT_EXPLORE_URL}/api/pairs/${chain_id}/${pair_address}/trades?limit=100&offset=0`
    fetch(url, { method: 'GET' })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setTradeHistory(data.data.data)
        }
      })
  }

  //获取流动性记录
  const getLiquidityHistory = () => {
    let params = (match.params || {}) as any
    let chain_id = params.chain_id;
    let pair_address = params.address;
    let url = `${DEFAULT_EXPLORE_URL}/api/pairs/${chain_id}/${pair_address}/liquidity?limit=100&offset=0`
    fetch(url, { method: 'GET' })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setLiquidityHistory(data.data.data)
        }
      })
  }



  const initCharts = () => {
    const locale = (store.get('i18nextLng') || 'en').startsWith('zh') ? 'zh-CN' : 'en-US'
    chart.current = init('chart', {
      layout: [
        {
          // type:klineType === 'line' ? 'area' : 'candle_solid',
          content: [{ name: 'MA', calcParams: [5, 10, 30] }],
          options: { order: Number.MIN_SAFE_INTEGER }
        } as any,
        // { type: 'indicator', content: ['VOL'], options: { order: 10 } } as any,
        { type: 'xAxis', options: { order: 9 } } as any
      ],
      locale: locale
    })
    chart.current.setStyles({
      candle: {
        type: klineType === 'line' ? 'area' : 'candle_solid',
        bar: {
          upColor: "#00C07B",
          upBorderColor: "#00C07B",
          noChangeColor: '#BCC4D1',
          downColor: "#FF3A5A",
          downBorderColor: "#FF3A5A",
        },
        area: {
          lineSize: 1.2,
          lineColor: '#FFBC2A',
          backgroundColor: [{
            offset: 0,
            color: '#FFBC2A1A'
          }, {
            offset: 1,
            color: '#FFBC2AAA'
          }],
        },
        tooltip: {
          text: { size: 10 },
          offsetLeft: 0,
          offsetTop: 0,
          offsetRight: 0,
          offsetBottom: 0,
          showRule: 'follow_cross',
          showType: 'rect',
        },
      },
      grid: {
        show: false,
      },
      xAxis: {
        tickText: {
          size: 10,
          color: "rgba(128,128,128,.5)",
        },
        axisLine: {
          color: "rgba(128, 128, 128, .2)",
        },
        tickLine: {
          color: "rgba(128, 128, 128, .2)",
        },
      },
      yAxis: {
        inside: true,
        tickText: {
          size: 10,
          color: "rgba(128,128,128,.5)",
        },
        axisLine: false,
        tickLine: {
          color: "rgba(128, 128, 128, .2)",
        },
      },
      separator: {
        color: "rgba(128, 128, 128, .2)",
      },
      crosshair: {
        horizontal: {
          line: {
            color: "rgba(128, 128, 128, .2)",
          },
        },
        vertical: {
          line: {
            color: "rgba(128, 128, 128, .2)",
          },
        },
      },
      indicator: {
        tooltip: {
          text: { size: 10 }
        },
        bars: [{
          upColor: "#00C07B",
          upBorderColor: "#00C07B",
          noChangeColor: '#BCC4D1',
          downColor: "#FF3A5A",
          downBorderColor: "#FF3A5A",
        }],
        lines: [
          {
            color: '#E8AF04',
            size: 2,
          },
          {
            color: '#D5319B',
            size: 2,
          },
          {
            color: '#594fBA',
            size: 2,
          }
        ]
      }
    })
    chart.current.setPrecision({
      price: 6,
      volume: 6
    })
    chart.current.setBarSpace(10)
    // chart.current.applyNewData([
    //   { timestamp: 1517846400000, open: 7424.6, high: 7511.3, low: 6032.3, close: 7310.1, volume: 224461 },
    //   { timestamp: 1517932800000, open: 7310.1, high: 8499.9, low: 6810, close: 8165.4, volume: 148807 },
    //   { timestamp: 1518019200000, open: 8166.7, high: 8700.8, low: 7400, close: 8245.1, volume: 24467 },
    //   { timestamp: 1518105600000, open: 8244, high: 8494, low: 7760, close: 8364, volume: 29834 },
    //   { timestamp: 1518192000000, open: 8363.6, high: 9036.7, low: 8269.8, close: 8311.9, volume: 28203 },
    //   { timestamp: 1518278400000, open: 8301, high: 8569.4, low: 7820.2, close: 8426, volume: 59854 },
    //   { timestamp: 1518364800000, open: 8426, high: 8838, low: 8024, close: 8640, volume: 54457 },
    //   { timestamp: 1518451200000, open: 8640, high: 8976.8, low: 8360, close: 8500, volume: 51156 },
    //   { timestamp: 1518537600000, open: 8504.9, high: 9307.3, low: 8474.3, close: 9307.3, volume: 49118 },
    //   { timestamp: 1518624000000, open: 9307.3, high: 9897, low: 9182.2, close: 9774, volume: 48092 }
    // ])


  }

  // //修改k线样式
  // const changeKlineType = (type: string) => {
  //   // klineType.value = type
  //   setKlineType(type)
  //   chart.current.setStyles({
  //     candle: { type: type === 'line' ? 'area' : 'candle_solid' }
  //   })
  //   // subscribeKline()
  // }
  //修改时间类型
  const changeTimeType = (type: string) => {
    // timeType.value = type
    setTimeType(type)
    // subscribeKline()
  }

  const changeTab = (index: number) => {
    setTabIndex(index)
  }

  //跳转一个新标签网页
  const openNewTab = (hash: string) => {
    // let https://www.kortho.io/#/Td20/9e2ff03386ec2840c3bc880f21d4526cf398a7323291199ffeb4694532f3dd1c
    let url = `https://nosscan.noschain.org/tx_detail?hash=${hash}`
    if (info?.chain_id === 2559) {
      url = `https://www.kortho.io/#/Td20/${hash}`
    }

    window.open(url, '_blank')
  }
  // 跳转交易页面
  const openTransaction = () => {
    let token0 = info?.token0
    let token1 = info?.token1
    history.push(`/swap?inputCurrency=${token0}&outputCurrency=${token1}`);
  }

  // const openFundPool = () => {
  //   let url = `https://kswap.web3s.finance/#/add/${info?.token0}/${info?.token1}`
  //   window.open(url, '_blank')
  // }

  // //跳转官方网址
  // const openWebsite = () => {
  //   let url = info?.website
  //   window.open(url, '_blank')
  // }


  return (
    <ExploreDetailWrapper>
      <RowView style={{ paddingTop: '18px' }}>
        <KLineView >
          <HeaderView>
            <CoinName>
              <Row style={{ borderColor: 'transparent', height: '24px' }}>
                {/* <Icon src={metaData?.logo_url || getTokenLogoURL(info?.chain_id, transformData(info)?.token0)} /> */}
                <Icon size={25} src={getTokenLogoURL(info?.chain_id, transformData(info)?.token0)} onError={loadDefaultImage} />
                <Icon size={12} style={{ marginLeft: '-14px', marginTop: '13px' }} src={getTokenLogoURL(info?.chain_id, transformData(info)?.token1)} onError={loadDefaultImage} />
                <InfoText style={{ fontSize: '16px', fontWeight: 600 }}>{transformData(info)?.token0_symbol}/{transformData(info)?.token1_symbol}</InfoText>
              </Row>
              <Row style={{ borderColor: 'transparent', height: '24px', marginTop: '9px' }}>
                <InfoText style={{ fontSize: '15px', fontWeight: 600, color: getColor(info?.price_24h_change) }}>{info.price_usd == 0 ? `${desensitizeNumber(info.price) || ""}${info.token1_symbol || ""} ` : `≈$${desensitizeNumber(info.price_usd)}`}</InfoText>
              </Row>
              <InfoText style={{ fontSize: '12px', fontWeight: 600, color: getColor(info?.price_24h_change) }}>{formatChg(info?.price_24h_change)}%</InfoText>

            </CoinName>
            <RowBetweenView style={{ width: 'auto' }}>
              <Column style={{ marginLeft: '12px' }}>
                <TextView style={{ lineHeight: '18px', color: '#8C8C8C' }}>{t("turnover")}(24H):<TextView style={{ color: theme.text1 }} fontWeight={600}>${getSizeUnit(info?.volume_24h_usd)}</TextView></TextView>
                <TextView style={{ lineHeight: '18px', marginTop: '4px', color: '#8C8C8C' }}>{t("holder")}:<TextView style={{ color: theme.text1 }} fontWeight={600}>{info?.holder_count > 1000 ? getSizeUnit(info?.holder_count) : info?.holder_count}</TextView></TextView>

                {/* <TextView style={{ marginTop: '4px' }}>{t("liquidity")}({info.token0_symbol}):<TextView fontWeight={500}>{getSizeUnit(info?.liquidity_token0)}</TextView></TextView> */}
              </Column>

              <Column style={{ marginLeft: '12px' }}>

                <TextView style={{ lineHeight: '18px', color: '#8C8C8C' }}>{t("liquidity_usd")}:<TextView style={{ color: theme.text1 }} fontWeight={600}>${getSizeUnit(info?.liquidity_usd)}</TextView></TextView>
                <TextView style={{ lineHeight: '18px', marginTop: '4px', color: '#8C8C8C' }}>{t("transactionCount")}(24H):<TextView style={{ color: theme.text1 }} fontWeight={600}>{info?.tx_count_24h > 1000 ? getSizeUnit(info?.tx_count_24h) : info?.tx_count_24h}</TextView></TextView>

                {/* <TextView style={{ marginTop: '4px' }}>{t("liquidity")}({info.token1_symbol}):<TextView fontWeight={500}>{getSizeUnit(info?.liquidity_token1)}</TextView></TextView> */}

              </Column>
              {/* <Column style={{ marginLeft: '12px' }}>
                <TextView>Mkt Cap:9000M</TextView>
                <TextView>Holders:125K</TextView>
              </Column> */}

            </RowBetweenView>

          </HeaderView>
          <Row style={{ marginTop: '6px', marginBottom: '0px' }}>
            <ActiveView active={timeType === '1m'} onClick={() => changeTimeType('1m')}>{t("kline_minutes", { num: 1 })}</ActiveView>
            <ActiveView active={timeType === '5m'} onClick={() => changeTimeType('5m')}>{t("kline_minutes", { num: 5 })}</ActiveView>
            <ActiveView active={timeType === '15m'} onClick={() => changeTimeType('15m')}>{t("kline_minutes", { num: 15 })}</ActiveView>
            <ActiveView active={timeType === '1h'} onClick={() => changeTimeType('1h')}>{t("kline_hours", { num: 1 })}</ActiveView>
            <ActiveView active={timeType === '4h'} onClick={() => changeTimeType('4h')}>{t("kline_hours", { num: 4 })}</ActiveView>
            <ActiveView active={timeType === '1d'} onClick={() => changeTimeType('1d')}>{t("kline_day", { num: 1 })}</ActiveView>
            <ActiveView active={timeType === '1w'} onClick={() => changeTimeType('1w')}>{t("kline_week", { num: 1 })}</ActiveView>
            <ActiveView active={timeType === '1M'} onClick={() => changeTimeType('1M')}>{t("kline_month", { num: 1 })}</ActiveView>
            <ActiveView hideOnMobile active={timeType === '1y'} onClick={() => changeTimeType('1y')}>{t("kline_year", { num: 1 })}</ActiveView>
          </Row>
          <div style={{ display: 'flex', position: 'relative', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
            <img height="30px" src={isDark ? LogoDark : Logo} alt="logo" style={{ position: 'absolute', opacity: 0.1, zoom: 1.5, zIndex: -1 }} />
            <ChartView id="chart" >

            </ChartView>
          </div>
          {/* <RowBetween>
            <Row>
              <ActiveView active={timeType === '1m'} onClick={() => changeTimeType('1m')}>1m</ActiveView>
              <ActiveView active={timeType === '5m'} onClick={() => changeTimeType('5m')}>5m</ActiveView>
              <ActiveView active={timeType === '1h'} onClick={() => changeTimeType('1h')}>1H</ActiveView>
              <ActiveView active={timeType === '1d'} onClick={() => changeTimeType('1d')}>1D</ActiveView>
              <ActiveView active={timeType === '1w'} onClick={() => changeTimeType('1w')}>1W</ActiveView>
              <ActiveView active={timeType === '1M'} onClick={() => changeTimeType('1M')}>1M</ActiveView>
              <ActiveView active={timeType === '1y'} onClick={() => changeTimeType('1y')}>1Y</ActiveView>
            </Row>
            <Row style={{}}>
              <ActiveView active={klineType === 'line'}>
                <LineIcon onClick={() => changeKlineType('line')} />
              </ActiveView>
              <ActiveView active={klineType === 'candle'}>
                <CandleIcon onClick={() => changeKlineType('candle')} />
              </ActiveView>
            </Row>

          </RowBetween> */}

        </KLineView>
        <InfoBody hide={true}>
          {t("infomation")}
          <Row style={{ borderColor: 'transparent', padding: '10px 0px' }}>
            <Row style={{ borderColor: 'transparent', padding: '10px 0px', marginRight: '12px', cursor: 'pointer' }}>
              <BlockIcon />
              {t("blockchainBrowser")}
            </Row>
            <Row style={{ borderColor: 'transparent', padding: '10px 0px', marginRight: '12px', cursor: 'pointer' }}>
              <WebsiteIcon />
              {t("officialWebsite")}
            </Row>

            <Row style={{ borderColor: 'transparent', padding: '10px 0px', marginRight: '12px', cursor: 'pointer' }}>
              <TwitterIcon />
              Twitter
            </Row>

          </Row>
          {/* <InfoText>
            Ethereum is a smart contract platform that enables developers to build tokens and decentralized applications (dapps). ETH is the native currency for the Ethereum platform and also works as the transaction fees to miners on the Ethereum network. Ethereum is the pioneer for blockchain based smart contracts. Smart contract is essentially a computer code that runs exactly as programmed without any possibility of downtime, censorship, fraud or third-party interference. It can facilitate the exchange of money, content, property, shares, or anything of value. When running on the blockchain a smart contract becomes like a self-operating computer program that automatically executes when specific conditions are met. Ethereum allows programmers to run complete-turing smart contracts that is capable of any customizations. Rather than giving a set of limited operations, Ethereum allows developers to have complete control over customization of their smart contract, giving developers the power to build unique and innovative applications. Ethereum being the first blockchain based smart contract platform, they have gained much popularity, resulting in new competitors fighting for market share. The competitors includes: Ethereum Classic which is the oldchain of Ethereum, Qtum, EOS, Neo, Icon, Tron and Cardano. Ethereum wallets are fairly simple to set up with multiple popular choices such as myetherwallet, metamask, and Trezor. Read here for more guide on using ethereum wallet: How to Use an Ethereum Wallet
          </InfoText> */}
        </InfoBody>
      </RowView>
      <RowBetween style={{ marginTop: '5px', marginBottom: '10px' }}>
        <LiquidityView>
          <TextView style={{ lineHeight: '18px', color: '#8C8C8C', textAlign: 'center' }}>{t("liquidity")}({info.token0_symbol}):<TextView style={{ color: theme.text1 }} fontWeight={500}>{getSizeUnit(info?.liquidity_token0)}</TextView></TextView>
          <div style={{ width: '1.5px', height: '20px', borderRadius: '2px', backgroundColor: '#505050', margin: '0px 10px' }} />
          <TextView style={{ lineHeight: '18px', color: '#8C8C8C', textAlign: 'center' }}>{t("liquidity")}({info.token1_symbol}):<TextView style={{ color: theme.text1 }} fontWeight={500}>{getSizeUnit(info?.liquidity_token1)}</TextView></TextView>
        </LiquidityView>
        <Row style={{ borderColor: 'transparent', padding: '10px 0px' }}>
          {/* <TradeButton onClick={openFundPool} style={{ backgroundColor: '#7367F9', marginRight: '12px' }}>
            {t("fund_pool")}
          </TradeButton> */}
          <TradeButton onClick={openTransaction}>
            {t("trade")}
          </TradeButton>
        </Row>
      </RowBetween>
      {/* <RowBetween> */}
      <TitleList>
        <Title active={tabIndex === 0} onClick={() => changeTab(0)}>{t("tabbarjy")}</Title>
        <Title active={tabIndex === 1} onClick={() => changeTab(1)}>{t("liquidity")}</Title>
        <Title hideOnPc style={{ display: 'none' }} active={tabIndex === 2} onClick={() => changeTab(2)}>{t("infomation")}</Title>
      </TitleList>


      {/* </RowBetween> */}

      {
        tabIndex === 0 &&
        (
          <>
            <HideView hide={true}>
              <TableView>
                <TableHeader >
                  <TableText flexBasis="0.2" style={{ fontWeight: 'bold' }}>{t("time")}</TableText>
                  <TableText hideOnMobile style={{ justifyContent: 'center', fontWeight: 'bold' }}>{t("type")}</TableText>
                  <TableText style={{ justifyContent: 'center', fontWeight: 'bold' }}>{t("price")}</TableText>

                  <TableText style={{ justifyContent: 'center', fontWeight: 'bold' }}>{t("transaction_volume")}({transformData(info)?.token0_symbol})</TableText>
                  <TableText style={{ justifyContent: 'center', fontWeight: 'bold' }}>{t("transaction_amount")}</TableText>
                  <TableText style={{ justifyContent: 'right', fontWeight: 'bold' }}>{t("sender")}</TableText>
                </TableHeader>
                {
                  tradeHistory.map((item, index) => {
                    return (
                      <ListItem key={index} >
                        <TableText flexBasis="0.2">{formatTime(item.timestamp)}</TableText>
                        <TableText hideOnMobile style={{ justifyContent: 'center', alignItems: 'center', color: getColor(item.trade_type == 'buy' ? 1 : -1) }}>
                          {/* <Icon src={'/static/media/kto.f4270fd3.png'} /> */}
                          {t(item.trade_type)}
                        </TableText>
                        <TableText style={{ justifyContent: 'center', color: getColor(item.trade_type == 'buy' ? 1 : -1) }}>${desensitizeNumber(item.price_usd || 0, 6)}</TableText>

                        <TableText style={{ justifyContent: 'center', alignItems: 'center', }}>
                          <div>{getSizeUnit(transformData(item).amount0_in + transformData(item).amount0_out)}</div>
                          {/* <div>{getSizeUnit(item.amount0_in + item.amount0_out)}{item.token0_symbol}</div>
                      <div>{getSizeUnit(item.amount1_in + item.amount1_out)}{item.token1_symbol}</div> */}
                        </TableText>

                        <TableText style={{ justifyContent: 'center', color: getColor(item.trade_type == 'buy' ? 1 : -1) }}>${getSizeUnit(item.volume_usd || 0)}</TableText>
                        <TableText style={{ justifyContent: 'right' }}>{desensitizeString(item.sender, 0, 5)}</TableText>
                      </ListItem>
                    )
                  })
                }
              </TableView>
            </HideView>
            <HideView hide={false}>
              <Table>
                <tbody>
                  <Tr  >
                    <Th style={{ textAlign: 'left' }}>{t("time")}</Th>
                    <Th style={{ textAlign: 'left' }}>{t("price")}</Th>
                    <Th style={{ textAlign: 'left' }}>{t("transaction_volume")}({transformData(info)?.token0_symbol})</Th>
                    <Th style={{ textAlign: 'left' }}>{t("transaction_amount")}</Th>
                    <Th style={{ textAlign: 'right' }}>{t("sender")}</Th>
                  </Tr>
                  {
                    tradeHistory.map((item, index) => {
                      return (
                        <Tr key={index} style={{ fontSize: '11.5px' }}>
                          <Td style={{ textAlign: 'left' }}>{formatTime(item.timestamp, false)}</Td>

                          <Td style={{ textAlign: 'left', color: getColor(item.trade_type == 'buy' ? 1 : -1) }}>${desensitizeNumber(item.price_usd || 0, 6)}</Td>

                          <Td style={{ textAlign: 'left', }}>
                            {getSizeUnit(transformData(item).amount0_in + transformData(item).amount0_out)}
                          </Td>

                          <Td style={{ textAlign: 'left', color: getColor(item.trade_type == 'buy' ? 1 : -1) }}>${getSizeUnit(item.volume_usd || 0)}</Td>
                          <Td style={{ textAlign: 'right' }}>{desensitizeString(item.sender, 0, 4)}</Td>
                        </Tr>
                      )
                    })
                  }
                </tbody>
              </Table>

            </HideView>
          </>
        )
      }
      {
        tabIndex === 1 &&
        <TableView>
          <TableHeader>
            <TableText flexBasis="0.4" style={{ fontWeight: 'bold' }}>{t("time")}</TableText>
            <TableText flexBasis="0.8" style={{ justifyContent: 'center', fontWeight: 'bold' }}>{t("type")}</TableText>
            <TableText style={{ justifyContent: 'center', fontWeight: 'bold' }}>{t("transaction_volume")}</TableText>

            <TableText hideOnMobile style={{ justifyContent: 'center', fontWeight: 'bold' }}>USD</TableText>
            <TableText hideOnMobile style={{ justifyContent: 'center', fontWeight: 'bold' }}>{t("transaction_hash")}</TableText>
            <TableText style={{ justifyContent: 'right', fontWeight: 'bold' }}>{t("sender")}</TableText>
          </TableHeader>
          {
            liquidityHistory.map((item, index) => {
              return (
                <ListItem key={index} >
                  <TableText flexBasis="0.4" >{formatTime(item.timestamp)}</TableText>
                  <TableText flexBasis="0.8" style={{ justifyContent: 'center', color: getColor(item.liquidity_type == 'mint' ? 1 : -1) }}>
                    {t(item.liquidity_type)}
                  </TableText>
                  <TableText style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <div>{getSizeUnit(item.amount0)} {item.token0_symbol}</div>
                    <div>{getSizeUnit(item.amount1)} {item.token1_symbol}</div>
                  </TableText>


                  <TableText hideOnMobile style={{ justifyContent: 'center' }}>{getSizeUnit(item.volume_usd || 0)}</TableText>
                  <TableText hideOnMobile style={{ justifyContent: 'center', cursor: "pointer" }} onClick={() => { openNewTab(item.transaction_hash) }}>{desensitizeString(item.transaction_hash, 0, 6)}</TableText>

                  <TableText style={{ justifyContent: 'right', cursor: "pointer" }} onClick={() => { openNewTab(item.transaction_hash) }}>{desensitizeString(item.sender, 0, 6)}</TableText>
                </ListItem>
              )
            })
          }
        </TableView>

      }
      {tabIndex === 2 && <InfoBody hide={false} style={{ marginTop: '0px' }}>
        <Row style={{ borderColor: 'transparent', padding: '10px 0px' }}>
          <Row style={{ borderColor: 'transparent', padding: '10px 0px', marginRight: '12px', cursor: 'pointer' }}>
            <BlockIcon />
            {t("blockchainBrowser")}
          </Row>
          <Row style={{ borderColor: 'transparent', padding: '10px 0px', marginRight: '12px', cursor: 'pointer' }}>
            <WebsiteIcon />
            {t("officialWebsite")}
          </Row>
          <Row style={{ borderColor: 'transparent', padding: '10px 0px', marginRight: '12px', cursor: 'pointer' }}>
            <TwitterIcon />
            Twitter
          </Row>
        </Row>
        <InfoText>
          Ethereum is a smart contract platform that enables developers to build tokens and decentralized applications (dapps). ETH is the native currency for the Ethereum platform and also works as the transaction fees to miners on the Ethereum network. Ethereum is the pioneer for blockchain based smart contracts. Smart contract is essentially a computer code that runs exactly as programmed without any possibility of downtime, censorship, fraud or third-party interference. It can facilitate the exchange of money, content, property, shares, or anything of value. When running on the blockchain a smart contract becomes like a self-operating computer program that automatically executes when specific conditions are met. Ethereum allows programmers to run complete-turing smart contracts that is capable of any customizations. Rather than giving a set of limited operations, Ethereum allows developers to have complete control over customization of their smart contract, giving developers the power to build unique and innovative applications. Ethereum being the first blockchain based smart contract platform, they have gained much popularity, resulting in new competitors fighting for market share. The competitors includes: Ethereum Classic which is the oldchain of Ethereum, Qtum, EOS, Neo, Icon, Tron and Cardano. Ethereum wallets are fairly simple to set up with multiple popular choices such as myetherwallet, metamask, and Trezor. Read here for more guide on using ethereum wallet: How to Use an Ethereum Wallet
        </InfoText>
      </InfoBody>}

    </ExploreDetailWrapper >
  )
}